export default "__VITE_ASSET__91312159__"